"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterPanel = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _panel = _interopRequireDefault(require("../panel"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FooterPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FooterPanel, _Component);

  var _super = _createSuper(FooterPanel);

  function FooterPanel() {
    var _this;

    (0, _classCallCheck2.default)(this, FooterPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      title: '',
      url: ''
    });
    return _this;
  }

  (0, _createClass2.default)(FooterPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          links = _this$props.links,
          onAddLink = _this$props.onAddLink,
          onRemoveLink = _this$props.onRemoveLink,
          footerTitle = _this$props.footerTitle,
          onTitleChanged = _this$props.onTitleChanged,
          onLinkChanged = _this$props.onLinkChanged;
      var _this$state = this.state,
          title = _this$state.title,
          url = _this$state.url;
      return (0, _preact.h)(_panel.default, {
        title: "Footer",
        customClass: "footer_footer-panel"
      }, (0, _preact.h)("label", {
        className: "trigger-label"
      }, "Applicable for embeddable widget only. Footer will be shown on the home and topic pages of the embeddable widget."), (0, _preact.h)(_InputGroup.default, {
        title: "Title",
        type: "text",
        qaClasses: "footer_footer-title",
        onChange: function onChange(e) {
          onTitleChanged(e.target.value);
        },
        value: footerTitle
      }), (0, _preact.h)("div", {
        className: "footer_labels-wrapper"
      }, (0, _preact.h)("label", null, "External link text"), (0, _preact.h)("label", null, "External link URL")), links.map(function (link, idx) {
        return (0, _preact.h)("div", {
          key: idx,
          className: "footer_wrapper-inputs"
        }, (0, _preact.h)("input", {
          type: "text",
          className: "footer_footer-inputs",
          onChange: function onChange(e) {
            onLinkChanged(idx, e.target.value, link.url);
          },
          value: link.title
        }), (0, _preact.h)("input", {
          type: "text",
          className: "footer_footer-inputs long",
          onChange: function onChange(e) {
            onLinkChanged(idx, link.title, e.target.value);
          },
          value: link.url
        }), (0, _preact.h)(_buttonControl.default, {
          title: "Remove",
          onClick: function onClick() {
            return onRemoveLink(idx);
          },
          variant: "warning",
          class: "footer_add-more-links-button"
        }));
      }), (0, _preact.h)("div", {
        className: "footer_wrapper-inputs"
      }, (0, _preact.h)("input", {
        type: "text",
        placeholder: "Add link text",
        className: "footer_footer-inputs",
        onChange: function onChange(e) {
          _this2.setState({
            title: e.target.value
          });
        },
        value: title
      }), (0, _preact.h)("input", {
        type: "text",
        placeholder: "Add link URL",
        className: "footer_footer-inputs long",
        onChange: function onChange(e) {
          _this2.setState({
            url: e.target.value
          });
        },
        value: url
      }), (0, _preact.h)(_buttonControl.default, {
        title: "Add",
        onClick: function onClick() {
          onAddLink(_this2.state.title, _this2.state.url);

          _this2.setState({
            title: '',
            url: ''
          });
        },
        variant: "primary",
        class: "footer_add-more-links-button"
      })));
    }
  }]);
  return FooterPanel;
}(_preact.Component); // eslint-disable-next-line @typescript-eslint/consistent-type-exports


exports.FooterPanel = FooterPanel;